import React from 'react';
import { Button } from 'components';
import { UserService } from 'services';

interface Props {
  item?: any;
  onSelectUser: (user: any) => void;
}

interface IState {
  searchQuery: string
  isSearching: boolean
  selectedUser: any
  searchError: string
  submitting: boolean
}

class SearchAffiliate extends React.Component<Props, IState> {
  state = {
    searchQuery: '',
    isSearching: false,
    selectedUser: null as any,
    searchError: '',
    submitting: false,
  };

  componentDidMount() {
    if (this.props.item) {
      this.setState({ selectedUser: this.props.item });
    }
  }

  handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchQuery: e.target.value, searchError: '' });
  };

  searchUser = async () => {
    const { searchQuery } = this.state;

    if (!searchQuery.trim()) {
      this.setState({ searchError: 'Por favor, ingresa un término de búsqueda' });
      return;
    }

    this.setState({ isSearching: true, searchError: '', selectedUser: null });

    try {
      const response: any = await UserService.admin.get({
        search: searchQuery,
        level_id: 4,
        only_one: true
      });

      if (response && response.user) {
        this.setState({ selectedUser: response.user });
        this.props.onSelectUser(response.user);
      } else {
        this.setState({ searchError: 'No se encontró ningún afiliado con ese dato.' });
      }
    } catch (error) {
      console.error("Error al buscar usuario:", error);
      this.setState({ searchError: 'Ocurrió un error en el servidor al buscar.' });
    } finally {
      this.setState({ isSearching: false });
    }
  };

  render() {
    const { searchQuery, isSearching, selectedUser, searchError } = this.state;

    return (
      <div id="search-affiliate">
        <label className="label-input">Buscar Afiliado (Nombre o Documento)</label>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input
            type="text"
            className="form-control"
            placeholder="Ej: dr juan o V-12345678"
            value={searchQuery}
            onChange={this.handleSearchChange}
            onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), this.searchUser())}
            disabled={!!this.props.item}
          />
          <Button type="button" onClick={this.searchUser} disabled={isSearching || !!this.props.item}>
            {isSearching ? 'Buscando...' : 'Buscar'}
          </Button>
        </div>

        {/* UI Feedback: Mensajes de error o éxito */}
        {searchError && <small style={{ color: 'red', marginTop: '5px', display: 'block' }}>{searchError}</small>}

        {selectedUser && (
          <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#eef2f5', borderRadius: '5px' }}>
            <strong>Afiliado seleccionado:</strong><br />
            {selectedUser?.name} - {selectedUser?.document_format} <br />
            <small className="text-muted">{selectedUser?.email} | {selectedUser?.city?.name}</small>
          </div>
        )}
      </div>
    );
  }
}

export default SearchAffiliate;